import { useState } from "react";

import { glencocoClientAPI } from "@/api/glencoco";
import { uploadStableProfileImage } from "shared/lib/helpers/profile-image-upload";

/**
 * Uploads a new profile photo to a stable public URL (GLE-8239): the photo is
 * written once to a fresh key and saved to the profile only after the upload
 * succeeds. Resolves when the photo is saved; rejects otherwise, and callers
 * show their own copy.
 */
export const useUploadProfileImage = () => {
  const [isUploadingProfileImage, setIsUploadingProfileImage] = useState(false);

  const uploadProfileImage = async (file: File | undefined) => {
    if (!file) {
      return Promise.resolve();
    }

    setIsUploadingProfileImage(true);

    const API = glencocoClientAPI();

    try {
      await uploadStableProfileImage(file, {
        requestUpload: API.getProfileImageUploadURLV2,
        completeUpload: API.completeProfileImageUpload,
      });
      return Promise.resolve();
    } catch {
      return Promise.reject();
    } finally {
      setIsUploadingProfileImage(false);
    }
  };

  return {
    isUploadingProfileImage,
    uploadProfileImage,
  };
};
